export const REQUEST_MASTER_CONTACTUS = "REQUEST_MASTER_CONTACTUS";
export const SET_MASTER_CONTACTUS = "SET_MASTER_CONTACTUS";
export const ERROR_GET_MASTER_CONTACTUS = "ERROR_GET_MASTER_CONTACTUS";

export const REQUEST_UPDATE_MASTER_CONTACTUS =
  "REQUEST_UPDATE_MASTER_CONTACTUS";
export const SUCCESS_UPDATE_MASTER_CONTACTUS =
  "SUCCESS_UPDATE_MASTER_CONTACTUS";
export const ERROR_UPDATE_MASTER_CONTACTUS = "ERROR_UPDATE_MASTER_CONTACTUS";

export const SET_MESSAGE_MASTER_CONTACTUS = "SET_MESSAGE_MASTER_CONTACTUS";
